import {
  AddManageCapacity,
} from "../../../web/pages/ManageCapacity";
import React from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getNetworkStatus, getUserMasterData } from "../../../selectors/selector";
import { showNetworkAlert } from "../../../actions/App/action";
import { ICapacityPayload } from "../../../schemas/manage/manage.Schema";
import { CapacityModel } from "../../../models/manage/capacity.model";
import { ToastMessage } from "../../../utils/ToastMessage";
import { EDIT_CAPACITY_SUCCESS, OOPS_MESSAGE } from "../../../utils/constants";
import { getSelectedManageCapacity, countryStateCodesSelector } from "../../../selectors/Manage/selector";
import { updateManageCapacity, getCountryStateCodes } from "../../../actions/manage/action";
import { useLocation } from "react-router";

const path = "manage/ManageMyCapacity";

export const ManageCapacityEditContainer: React.FC<any> = (props: any) => {
  const {
    isNetWorkAvailable,
    showNetworkAlert,
    history,
    selectedCapacity,
    userDetails,
  } = props;
  const location = useLocation();

  const handleSubmit = (input: ICapacityPayload, clearFields: Function) => {
    if (!isNetWorkAvailable) {
      showNetworkAlert();
      return true;
    }
    const lastUpdatedBy = `${userDetails?.memberDetailsResponse?.member?.firstName} ${userDetails?.memberDetailsResponse?.member?.lastName}`;
    const capacityModel = new CapacityModel();
    const query = capacityModel.updateCapacity();
    const callback = (status: boolean) => {
      ToastMessage.show(status ? EDIT_CAPACITY_SUCCESS : OOPS_MESSAGE);
      if (status) {
        history.push(`/app/manage-capacity`);
      }
    };
    props.updateCapacityItem({
      params: { query, input, lastUpdatedBy },
      callback,
    });
  };

  const editPageToBeShown = (): boolean => {
    const state: any = (location?.state) ?? {};
    return state.showPage;
  };

  return selectedCapacity && editPageToBeShown() ? (
    <AddManageCapacity
      module={`${path}/Edit`}
      {...props}
      handleSubmit={handleSubmit}
      isEditPage={true}
    />
  ) : null;
};

const mapStateToProps = createStructuredSelector({
  isNetWorkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  selectedCapacity: getSelectedManageCapacity(),
  countryStateCodes: countryStateCodesSelector()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  updateCapacityItem: (payload: any) => dispatch(updateManageCapacity(payload)),
  getCountryStateCodes: () => dispatch(getCountryStateCodes()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCapacityEditContainer);
